<template>
  <a href="#" :class="{'!text-red-600': isActive, 'muted': !isActive}" v-if="show" @click.prevent="click">
    <aw-icon
      v-if="loading"
      icon="loading"
      class="animate-spin w-5 h-5 "
    />
    <aw-icon v-else icon="pen" class="w-5 h-5 " />
    {{$t('Edit')}}
  </a>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import editDocumentOrFolder from '../../mixins/actions/EditDocumentOrFolder'

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    show () {
      if (this.bcFolderStore.current?.can_edit) {
        return true
      }

      for (let item of this.bcSelectedStore.selectableMap.values()) {
        if (item.can_edit) {
          return true
        }
      }
      
      return false
    },
    isActive () {
      return this.bcSelectedStore.listSelected.length === 1 && this.bcSelectedStore.listSelected[0].can_edit
    },
    ...mapStores(useBcSelectedStore, useBcFolderStore),
  },
  methods: {
    async click() {
      this.loading = true
      await editDocumentOrFolder(this.bcSelectedStore.listSelected[0], this.$store, this.$formValues)
      this.loading = false
    }
  },
}
</script>

<style lang="scss" scoped></style>
